/**
 * Config Redux Reducer
 */

import { compileFederatedLoginUrl, compileLogoutUrl } from '../../utils/authentication';
import * as action from '../actions/authentication';

import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

type ReducerState = IAuthenticationState;
type Handler<K = undefined> = ReducerHandler<ReducerState, K>;

const initialState: ReducerState = {
  facebookLoginUrl: '',
  googleLoginUrl: '',
  logoutUrl: '',
  userPool: null,
};

const setAuthenticationConfigHandler: Handler<GQL.IAuthenticationInfo> =
  (state, { client_id, cognito_domain_url, user_pool_id }) => {
    const baseFederatedLoginUrl = compileFederatedLoginUrl({ client_id, cognito_domain_url });
    return {
      facebookLoginUrl: `${baseFederatedLoginUrl}&identity_provider=Facebook`,
      googleLoginUrl: `${baseFederatedLoginUrl}&identity_provider=Google`,
      logoutUrl: compileLogoutUrl({ client_id, cognito_domain_url }),
      userPool: new CognitoUserPool({ ClientId: client_id, UserPoolId: user_pool_id }),
    };
  };

export default reducerWithInitialState(initialState)
  .case(action.setAuthenticationConfig, setAuthenticationConfigHandler);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/reducers/authentication.ts